import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type UpdateBoardUserSettingV3 = OpalApi<'UpdateBoardUserSettingV3', 200>

export const updateBoardUserSetting: UpdateBoardUserSettingV3 = async (
  args = {}
) => {
  const boardId = args.params?.path.board_id

  if (typeof boardId !== 'string') {
    throw new Error('Must supply a valid board_id.')
  }

  const url = new URL(
    `/boards/v3/${boardId}/user_setting`,
    window.location.origin
  )

  return HttpClient()
    .patch(url.toString(), args.requestBody)
    .then((res) => res.data)
}
